import { Map } from 'immutable';
import { LoadingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_ID_LOGIN,
	ID_LOGIN_SUCCESS,
	ID_LOGIN_FAILED,
	START_ANONYMOUS_LOGIN,
	ANONYMOUS_LOGIN_SUCCESS,
	ANONYMOUS_LOGIN_FAILED,
	START_CHECK_AUTH,
	CHECK_AUTH_SUCCESS,
	CHECK_AUTH_FAILED,
	START_FETCH_ME,
	FETCH_ME_SUCCESS,
	FETCH_ME_FAILED,
	START_UPDATE_ME_LANGUAGE_CODE,
	UPDATE_ME_LANGUAGE_CODE_SUCCESS,
	UPDATE_ME_LANGUAGE_CODE_FAILED,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
	FAILED,
} = LoadingStatusEnum;
const initialState = Map({
	me: Map(),

	loadingStatus: NONE,
	loadingStatusMessage: '',

	idLoginLoadingStatus: NONE,
	idLoginLoadingStatusMessage: '',

	anonymousLoginLoadingStatus: NONE,
	anonymousLoginLoadingStatusMessage: '',

	fetchMeLoadingStatus: NONE,
	fetchMeLoadingStatusMessage: '',
	fetchMeLoadingStatusMessageCode: '',

	updateLanguageLoadingStatus: NONE,
	updateLanguageLoadingStatusMessage: '',
});

export default function auth(state = initialState, action) {
	switch (action.type) {
		case START_ID_LOGIN:
			return state
				.set('idLoginLoadingStatus', LOADING)
				.set('loadingStatus', NONE);

		case ID_LOGIN_SUCCESS:
			return state
				.set('idLoginLoadingStatus', SUCCESS);

		case ID_LOGIN_FAILED:
			return state
				.set('idLoginLoadingStatus', FAILED)
				.set('idLoginLoadingStatusMessage', action.errorMessage);

		case START_ANONYMOUS_LOGIN:
			return state
				.set('anonymousLoginLoadingStatus', LOADING)
				.set('loadingStatus', NONE);

		case ANONYMOUS_LOGIN_SUCCESS:
			return state
				.set('anonymousLoginLoadingStatus', SUCCESS);

		case ANONYMOUS_LOGIN_FAILED:
			return state
				.set('anonymousLoginLoadingStatus', FAILED)
				.set('anonymousLoginLoadingStatusMessage', action.errorMessage);

		case START_CHECK_AUTH:
			return state.set('loadingStatus', LOADING);

		case CHECK_AUTH_SUCCESS:
			return state
				.set('me', Map(action.me))
				.set('loadingStatus', SUCCESS);

		case CHECK_AUTH_FAILED:
			return state
				.set('loadingStatus', FAILED)
				.set('loadingStatusMessage', action.errorMessage);

		case START_FETCH_ME:
			return state.set('fetchMeLoadingStatus', LOADING);

		case FETCH_ME_SUCCESS:
			return state
				.set('me', Map(action.me))
				.set('fetchMeLoadingStatus', SUCCESS);

		case FETCH_ME_FAILED:
			return state
				.set('me', Map({}))
				.set('fetchMeLoadingStatus', FAILED)
				.set('fetchMeLoadingStatusMessage', action.errorMessage)
				.set('fetchMeLoadingStatusMessageCode', action?.error?.response?.code);

		case START_UPDATE_ME_LANGUAGE_CODE:
			return state
				.set('updateLanguageLoadingStatus', LOADING);

		case UPDATE_ME_LANGUAGE_CODE_SUCCESS:
			return state
				.set('updateLanguageLoadingStatus', SUCCESS);

		case UPDATE_ME_LANGUAGE_CODE_FAILED:
			return state
				.set('updateLanguageLoadingStatus', FAILED)
				.set('updateLanguageLoadingStatusMessage', action.errorMessage);

		default:
			return state;
	}
}
